import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";

const keyList = {
    smsUpdate : 'DASHBOARD_UPDATE',
    smsDelete : 'DASHBOARD_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        dashboard_count: {},
        dashboardCountLoading: false,
        dashboardCountError: false,
        
        feature_frequency: {},
        featureFrequencyLoading: false,
        featureFrequencyError: false,

        activity_frequency: {},
        activityFrequencyLoading: false,
        activityFrequencyError: false,

        user_type_graph: {},
        userTypeGraphLoading: false,
        userTypeGraphError: false,
 

        ...store
    },

    mutations : {
        ...mutations,

        SET_DASHBOARD_COUNT(state, items) {
            state.dashboard_count = items;
        },
     
        DASHBOARD_COUNT_LOADING (state, loading) {
            state.dashboardCountLoading = loading;
        },

        DASHBOARD_COUNT_ERROR (state, hasError) {
            state.dashboardCountError = hasError;
        },

        SET_FEATURE_FREQUENCY(state, items) {
            state.feature_frequency = items;
        },
     
        FEATURE_FREQUENCY_LOADING (state, loading) {
            state.featureFrequencyLoading = loading;
        },

        FEATURE_FREQUENCY_ERROR (state, hasError) {
            state.featureFrequencyError = hasError;
        },

        SET_ACTIVITY_FREQUENCY(state, items) {
            state.activity_frequency = items;
        },
     
        ACTIVITY_FREQUENCY_LOADING (state, loading) {
            state.activityFrequencyLoading = loading;
        },

        ACTIVITY_FREQUENCY_ERROR (state, hasError) {
            state.activityFrequencyError = hasError;
        },

        SET_USER_TYPE_GRAPH(state, items) {
            state.user_type_graph = items;
        },
     
        USER_TYPE_GRAPH_LOADING (state, loading) {
            state.userTypeGraphLoading = loading;
        },

        USER_TYPE_GRAPH_ERROR (state, hasError) {
            state.userTypeGraphError = hasError;
        }
    },

    actions: {
        async fetchDashboardCount ({ commit }) {
            commit('DASHBOARD_COUNT_LOADING', true);
            commit('DASHBOARD_COUNT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.get_dashboard_count, config);
                let response = result.data
                commit('SET_DASHBOARD_COUNT', response);

            } catch(error) {
                commit('DASHBOARD_COUNT_ERROR', true);
            } finally {
                commit('DASHBOARD_COUNT_LOADING', false);
            }
        },

        async fetchFeatureFrequency ({ commit }, payload) {
            commit('FEATURE_FREQUENCY_LOADING', true);
            commit('FEATURE_FREQUENCY_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try { 
                let params = new URLSearchParams();
        
                if (payload.date_from) params.append('date_from', payload.date_from);
                if (payload.date_to) params.append('date_to', payload.date_to);

                let url = V1API.get_feature_frequency + '?' + params.toString();
                let result = await axios.get(url, config);
                const response = result.data
                commit('SET_FEATURE_FREQUENCY', response.data);
                return result;
            } catch(error) {
                commit('FEATURE_FREQUENCY_ERROR', true);
            } finally {
                commit('FEATURE_FREQUENCY_LOADING', false);
            }
        },

        async fetchActivityFrequency ({ commit }, payload) {
            commit('ACTIVITY_FREQUENCY_LOADING', true);
            commit('ACTIVITY_FREQUENCY_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
        
                if (payload.date_from) params.append('date_from', payload.date_from);
                if (payload.date_to) params.append('date_to', payload.date_to);

                let url = V1API.get_activity_frequency + '?' + params.toString();
                let result = await axios.get(url, config);
                let response = result.data
                commit('SET_ACTIVITY_FREQUENCY', response.data);

            } catch(error) {
                commit('ACTIVITY_FREQUENCY_ERROR', true);
            } finally {
                commit('ACTIVITY_FREQUENCY_LOADING', false);
            }
        },

        async fetchUserTypeGraph ({ commit }, payload) {
            commit('USER_TYPE_GRAPH_LOADING', true);
            commit('USER_TYPE_GRAPH_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
        
                if (payload.date_from) params.append('date_from', payload.date_from);
                if (payload.date_to) params.append('date_to', payload.date_to);

                let url = V1API.get_user_type_graph + '?' + params.toString();
                let result = await axios.get(url, config);
                let response = result.data
                commit('SET_USER_TYPE_GRAPH', response.data);

            } catch(error) {
                commit('USER_TYPE_GRAPH_ERROR', true);
            } finally {
                commit('USER_TYPE_GRAPH_LOADING', false);
            }
        },
    },

    getters: {}
}
